<template>
	<div class="row">
		<div class="col-sm-6">
			<input-wrapper
				id="proposal_email_template"
				label="Proposal Email Template"
			>
				<textarea 
					id="proposal_email_template" 
					cols="30" 
					rows="10" 
					class="form-control"
					v-model="initialData.settings.proposal_email_template"
					:disabled="isLoading">
				</textarea>
			</input-wrapper>
		</div>
		<div class="col-sm-6">
			<input-wrapper
				id="invoice_email_template"
				label="Invoice Email Template"
			>
				<textarea 
					id="invoice_email_template" 
					cols="30" 
					rows="10" 
					class="form-control"
					v-model="initialData.settings.invoice_email_template"
					:disabled="isLoading">
				</textarea>
			</input-wrapper>
		</div>
		<div class="col-xs-12">
			<b>Available Shortcode</b>
			<p>
				%%CUSTOMER_NAME%% - Will Replace with customer's name<br/>
				%%CUSTOMER_COMPANY%% - Will Replace with customer's company name
			</p>
		</div>
	</div>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import { defaultFields } from './helpers';

export default {
	components: {
		InputWrapper,
	},
	props: {
		initialData: {
			type: Object,
			default: defaultFields,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
